import { Action, Dispatch } from "redux";
import { AdvertiseDto } from "../../dto/vending/AdvertiseDto";
import { MachineDto } from "../../dto/vending/MachineDto";
import { OrderInfoDto } from "../../dto/vending/OrderInfoDto";
import { FGetState } from "../app.reducer";
/**
 * Functon type declare
 */
export type FuncAction = (
    dispatch: Dispatch,
    getState: FGetState
) => Promise<void>;

/**
 * Function sync type declare
 */
export type FuncSyncAction = (dispatch: Dispatch, getState: FGetState) => void;

/**
 * Store action type declare
 */
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    GET_VM_INFO: {
        LOADING: "GET_VM_INFO_LOADING",
        SUCCESS: "GET_VM_INFO_SUCCESS",
        CLEAN: "GET_VM_INFO_CLEAN",
        ERROR: "GET_VM_INFO_ERROR",
        UP_STATUS: "UP_STATUS",
    },
    GET_LIST_VM: {
        LOADING: "GET_LIST_VM_LOADING",
        SUCCESS: "GET_LIST_VM_SUCCESS",
        ERROR: "GET_LIST_VM_ERROR",
    },
    ADVERTISE: {
        LOADING: "ADVERTISE_LOADING",
        SUCCESS: "ADVERTISE_SUCCESS",
        CLEAN: "ADVERTISE_CLEAN",
        ERROR: "ADVERTISE_ERROR",
    },
    SYNC_DATA: {
        LOADING: "SYNC_DATA_LOADING",
        SUCCESS: "SYNC_DATA_SUCCESS",
        CLEAN: "SYNC_DATA_CLEAN",
        ERROR: "SYNC_DATA_ERROR",
    },
    GET_ORDER_INFO: {
        LOADING: "GET_ORDER_INFO_LOADING",
        SUCCESS: "GET_ORDER_INFO_SUCCESS",
        CLEAN: "GET_ORDER_INFO_CLEAN",
        ERROR: "GET_ORDER_INFO_ERROR",
    }
};

/**
 * All store state
 */
export interface VMState {
    vendingInfo: MachineDto;
    orderInfo: Array<OrderInfoDto>;
    advertiseList: Array<AdvertiseDto>;
    upStatus: string;
    isLoading?: boolean;
    error?: any;
}

/**
 * Store's action definition
 */
export interface IVMAction extends Action {
    payload: any;
    error: any;
}
